module.exports = __webpack_public_path__ + "img/9.c4b4137d.png";